export default __webpack_public_path__ + "static/media/a038-3.28fc010a.svg";